/* HZ Studio — Pflicht: mind. 1 Foto pro sichtbarem Lampenschirm (20.07.2026) */
(function () {
  var MSG_ID = 'hz-photo-required-msg';
  function visibleRings() {
    return Array.prototype.filter.call(document.querySelectorAll('.hz-litho-ring'), function (r) {
      return !r.hidden && r.offsetParent !== null;
    });
  }
  function ringOk(r) {
    return Array.prototype.some.call(r.querySelectorAll('input[type=file]'), function (i) {
      return i.files && i.files.length > 0;
    });
  }
  function addButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"] [name=add]'));
  }
  function allOk() {
    var rs = visibleRings();
    return rs.length > 0 ? rs.every(ringOk) : true;
  }
  function msgEl() {
    var m = document.getElementById(MSG_ID);
    if (!m) {
      m = document.createElement('p');
      m.id = MSG_ID;
      m.textContent = 'Bitte lade für jeden Lampenschirm mindestens ein Foto hoch, um fortzufahren.';
      m.style.cssText = 'margin:8px 0;font-size:0.85rem;font-weight:600;color:#b23b3b;';
      var b = addButtons()[0];
      if (b && b.parentNode) {
        b.parentNode.insertBefore(m, b);
      } else {
        var p = document.querySelector('.hz-litho-personalization');
        if (p) p.appendChild(m);
      }
    }
    return m;
  }
  function validate() {
    if (document.querySelectorAll('.hz-litho-ring').length === 0) return;
    var ok = allOk();
    addButtons().forEach(function (b) {
      b.disabled = !ok;
      b.style.opacity = ok ? '' : '0.5';
      b.style.cursor = ok ? '' : 'not-allowed';
    });
    var m = msgEl();
    m.style.display = ok ? 'none' : '';
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.type === 'file') validate(); }, true);
  document.addEventListener('shopify:product:select', function () { setTimeout(validate, 60); });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1 && !allOk()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      validate();
      var m = document.getElementById(MSG_ID);
      if (m) m.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);
  if (document.readyState !== 'loading') setTimeout(validate, 300);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(validate, 300); });
  setTimeout(validate, 1200);
})();
